export const languages = {
  en: 'English',
  de: 'Deutsch',
  ru: 'Русский',
  es: 'Español',
  it: 'Italiano',
  hi: 'हिन्दी',
  zh: '汉语',
  fr: 'Français',
  mn: 'Монгол хэл',
}

export const langDefault = 'en'

export const appWalletGoogle = 'https://play.google.com/store/apps/details?id=com.ultimawallet'
export const appWalletApple = 'https://apps.apple.com/us/app/ultima-wallet/id1601950194'
export const appFarmGoogle = 'https://play.google.com/store/apps/details?id=com.plcu.farm'
export const appFarmApple = 'https://apps.apple.com/us/app/ultima-farm/id1602005130'

export const breakpoints = {
  phone: 0,
  tablet: 768,
  desktop: 1200,
}
